import { render, staticRenderFns } from "./SplitBill.vue?vue&type=template&id=6776ea52&"
import script from "./SplitBill.vue?vue&type=script&lang=js&"
export * from "./SplitBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports